<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
  >
    <v-card>
      <v-card-title class="title pt-5 pb-0">
        Pagamento via PIX
      </v-card-title>

      <v-card-text class="pt-2 pb-4 text-center">
        <p class="mb-4">
          Escaneie o QR Code ou copie o código para pagamento:
        </p>

        <div class="mb-4">
          <v-img
            :src="qrCodeUrl"
            max-width="300"
            max-height="300"
            class="mx-auto"
            contain
          />
        </div>

        <v-text-field
          :value="codigoPix"
          label="Código PIX (Copiar e Colar)"
          outlined
          readonly
          class="mb-4"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  @click="copiarCodigo"
                >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Copiar código</span>
            </v-tooltip>
          </template>
        </v-text-field>

        <v-alert
          v-if="mensagemProcessamento"
          type="info"
          class="mb-4"
        >
          {{ mensagemProcessamento }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="pt-0 pb-4 flex-column flex-sm-row">
        <v-spacer />
        <div class="d-flex flex-column flex-sm-row align-center">
          <v-btn
            color="grey"
            text
            class="mb-2 mb-sm-0 mr-sm-2"
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            class="mb-2 mb-sm-0 mr-sm-2"
            @click="trocarFormaPagamento"
          >
            Trocar Forma de Pagamento
          </v-btn>
          <v-btn
            color="success"
            text
            class="mb-0"
            :loading="loadingConfirmar"
            :disabled="loadingConfirmar"
            @click="confirmarPagamento"
          >
            Confirmar Pagamento
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiCompras from '@/api/compras';

export default {
  name: 'ModalPagamentoPix',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    compraId: {
      type: Number,
      default: null,
    },
    // These props are correctly named to match the data sent from the parent
    qrCode: {
      type: String,
      default: '',
    },
    codigoPix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      loadingConfirmar: false,
      mensagemProcessamento: '',
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    qrCodeUrl() {
      return this.qrCode || '';
    },
  },
  methods: {
    copiarCodigo() {
      navigator.clipboard.writeText(this.codigoPix);
      this.$toast.success('Código PIX copiado!');
    },
    trocarFormaPagamento() {
      this.$router.push(`/minhas-compras/gerenciar-pagamento-assinatura/${this.compraId}`);
      this.dialog = false;
    },
    async confirmarPagamento() {
      this.loadingConfirmar = true;
      this.mensagemProcessamento = '';

      try {
        // Fazer chamada para verificar o status do pagamento PIX usando a função existente
        const response = await ApiCompras.orderDetails(this.compraId);

        if (response.data) {
          const order = response.data;

          // Verificar se o pagamento foi confirmado (status ativo)
          if (order.membership_status === 'Ativa' || order.status === 'Pagamento aprovado') {
            // Pagamento confirmado - fechar modal e atualizar listagem
            this.dialog = false;
            this.$emit('dataUpdated');
          } else {
            // Pagamento ainda em processamento
            this.mensagemProcessamento = 'Estamos processando seu pagamento. A ativação da assinatura pode levar alguns minutos.';
          }
        } else {
          // Erro na consulta
          this.mensagemProcessamento = 'Estamos processando seu pagamento. A ativação da assinatura pode levar alguns minutos.';
        }
      } catch (error) {
        // Em caso de erro, mostrar mensagem de processamento
        this.mensagemProcessamento = 'Estamos processando seu pagamento. A ativação da assinatura pode levar alguns minutos.';
      } finally {
        this.loadingConfirmar = false;
      }
    },
  },
};
</script>
